import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as onboardingService from '../services/onboardingService';
import type { OnboardingPatch } from '../types/onboarding';

export const onboardingKeys = {
  all: ['onboarding'] as const,
  state: () => [...onboardingKeys.all, 'state'] as const,
};

export function useOnboardingState(enabled = true) {
  return useQuery({
    queryKey: onboardingKeys.state(),
    queryFn: onboardingService.getOnboardingState,
    staleTime: 60 * 1000,
    enabled,
  });
}

export function usePatchOnboarding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: OnboardingPatch) => onboardingService.patchOnboarding(patch),
    onSuccess: (data) => {
      qc.setQueryData(onboardingKeys.state(), data);
    },
  });
}

export function useCompleteOnboarding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: onboardingService.completeOnboarding,
    onSuccess: (data) => {
      qc.setQueryData(onboardingKeys.state(), data);
      qc.invalidateQueries({ queryKey: ['accounts'] });
    },
  });
}
